// extracted by mini-css-extract-plugin
module.exports = {"savedFiltersBtn":"SavedFiltersDropdown_savedFiltersBtn__Mbp7E"};